import React, {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import {postDanai} from "../../util/ajax";
import IconPromo from "../../../assets/img/icon/news-feed-ic-promo.svg";
import Moment from "moment/moment";

function MediaInformasi() {
    const [promoEvent, setPromoEvents] = useState([])
    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/promoEvents', function (resp) {
            console.log(resp);
            setPromoEvents(resp.data);
        }, function () {
        });
    }, []);
    const promoCategory = promoEvent.map((_, index) => (
        promoEvent[index].category
    ));
    const uniqueNames = promoCategory.filter((val, id, array) => array.indexOf(val) === id);

    const [searchParams] = useSearchParams();
    const category = searchParams.get("category");
    let dataOneCategory;
    if (category !== null) {
        dataOneCategory = promoEvent.filter(data => data.category === category);
    } else {
        dataOneCategory = promoEvent;
    }
    console.log(dataOneCategory);

    return (
        <>
            <div className="event-promo">
                <div className="general-container">
                    <header>
                        <div className="ui-g-12">
                            <ul className="breadcrumb">
                                <li><Link to="/">Beranda</Link></li>
                                <li>Media Informasi</li>
                            </ul>
                        </div>
                    </header>
                </div>
            </div>
            <div className="category-new">
                <div className="category-list-new">
                    <Link to='/media-informasi' className={`${category === null ? 'active' : ''}`}>Semua</Link>
                </div>
                {Array.from({length: uniqueNames.length}).map((_, index) => (
                        <div className="category-list-new">
                            <Link to={{pathname: '/media-informasi', search: `?category=${uniqueNames[index]}`}}
                                  className={`${category === uniqueNames[index] ? 'active' : ''}`}>{uniqueNames[index]}</Link>
                        </div>
                    )
                )}
            </div>
            <div className="container-media-informasi">
                {Array.from({length: dataOneCategory.length}).map((_, index) => (
                    <Link className="card-news" to={{
                        pathname: '/promo-detail',
                        search: `?id=${dataOneCategory[index].id}`,
                    }} preventScrollReset={true} rel="noreferrer">
                        <div className="img-promo">
                            <img src={dataOneCategory[index].imageUrl} alt="promo"/>
                        </div>
                        <div className="text-promo">
                            <div className="space-between">
                                <div
                                    className={`category-promo ${dataOneCategory[index].category === 'Informasi' ? 'informasi' : ''} gap-1`}>
                                    <img src={IconPromo} alt="icon category"/>
                                    <p className="text-category text-blue-700 m-0">{dataOneCategory[index].category}</p>
                                </div>
                                <div className="timestamp">
                                    <p className="text text-green-800 m-0">{Moment(dataOneCategory[index].createdTimestamp).format('DD MMMM yyyy')}</p>
                                </div>
                            </div>
                            <p className="text">{dataOneCategory[index].title}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
}

export default MediaInformasi;